// Concept projects (fictional businesses). To add screenshots later, put files in
// /public/images/work/ and set beforeImage / afterImage, e.g. "/images/work/trade-before.jpg".
export const PROJECTS = [
  {
    id: "trade",
    industry: "HVAC & plumbing",
    name: "Kestrel Heating & Plumbing",
    short: "Kestrel",
    icon: "Flame",
    accent: "#FF7A1A",
    summary:
      "A busy trade business whose old site hides the phone number and buries its services several clicks deep.",
    focus: [
      "Tap-to-call button that stays on screen on phones",
      "Clear service list: heating, cooling, and plumbing",
      "Short quote request form instead of a long contact page",
    ],
    beforeImage: "",
    afterImage: "",
  },
  {
    id: "auto",
    industry: "Auto repair",
    name: "Garnet Street Auto",
    short: "Garnet St.",
    icon: "Car",
    accent: "#F0525A",
    summary:
      "An independent repair shop with a site that looks dated on phones and makes it hard to book a visit.",
    focus: [
      "Online appointment requests by type of service",
      "Hours, address, and directions right at the top",
      "Simple pages for brakes, tires, inspections, and more",
    ],
    beforeImage: "",
    afterImage: "",
  },
  {
    id: "barber",
    industry: "Barber shop",
    name: "Sixpenny Barber Co.",
    short: "Sixpenny",
    icon: "Scissors",
    accent: "#E8B04A",
    summary:
      "A neighborhood barber relying on an outdated page and phone calls to fill the chair.",
    focus: [
      "Online booking, front and center",
      "A clear menu of cuts and services",
      "A photo gallery that shows off the work",
    ],
    beforeImage: "",
    afterImage: "",
  },
];
